const mixin = {
    methods: {
        getClients(){
            var self = this
            self.$root.ui.loading.push('pageLoading')
            return self.$store.dispatch('getClients').then(function(res){
                self.$root.ui.stopLoading('pageLoading')
            })
        },
        getClientById(id){
            var self = this
            if( (id || id == 0) && self.clients.length){
                for( let i = 0; i < self.clients.length; i++ ){
                    let lc = self.clients[i];
                    if( lc.id == parseInt(id) )
                        return lc
                }
                /*
                return self.clients.find(function (d) {
                    return parseInt(d.id) === parseInt(id)
                })
                */
            }
            return null;
        },
        getClientByName(name){
            var self = this
            if( name && self.clients.length){
                for( let i = 0; i < self.clients.length; i++ ){
                    let lc = self.clients[i];
                    if( lc.name == name )
                        return lc
                }
                /*
                return self.clients.find(function (d) {
                    return parseInt(d.id) === parseInt(id)
                })
                */
            }
            return null;
        }
    },
    created(){
        this.getClients()
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/clients.js